/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton'
import Typography from '@material-ui/core/Typography'
import Dialog from '@material-ui/core/Dialog';
import InputAdornment from '@material-ui/core/InputAdornment';

import { ZoomIn , ZoomOut, KeyboardArrowRight, KeyboardArrowLeft, Fullscreen, FullscreenExit ,CloudDownload} from '@material-ui/icons'

import { Document, Page } from 'react-pdf';
import { pdfjs } from 'react-pdf';
import toPx from 'unit-to-px'
import { Input, TextField, Tooltip, InputBase } from '@material-ui/core';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const highlightPattern = (text, pattern) => {
    const splitText = text.split(pattern);
  
    if (splitText.length <= 1) {
      return text;
    }
  
    const matches = text.match(pattern);
  
    return splitText.reduce((arr, element, index) => (matches[index] ? [
      ...arr,
      element,
      <mark>
        {matches[index]}
      </mark>,
    ] : [...arr, element]), []);
  };


class PDFViewer extends Component {
    state = {
        numPages: null,
        pageNumber: null,
        containerWidth : 0,
        open: false,
        searchText: this.props.searchText
    }

    componentWillMount () {
        this.setState({
            pageNumber: this.props.pageNumber,
            containerWidth : toPx('vw') * this.props.width,
            searchText: this.props.highlight
        })
    }


    onDocumentLoadSuccess = ({ numPages }) => {
        this.setState({ numPages });
    }

    zoomIn = () => {
        this.setState({
            containerWidth: this.state.containerWidth + 100
        }, () => {
            this.removeTextLayerOffset()
        })
    }

    zoomOut = () => {
        this.setState({
            containerWidth: this.state.containerWidth - 100
        }, () => {
            this.removeTextLayerOffset()
        })
    }

    // nextPage = () => {
    //     this.setState({
    //         pageNumber : this.state.pageNumber + 1
    //     })
    // }

    // prevPage = () => {
    //     this.setState({
    //         pageNumber : this.state.pageNumber - 1
    //     })
    // }

    removeTextLayerOffset = () => {
        const textLayers = document.querySelectorAll(".react-pdf__Page__textContent");
            textLayers.forEach(layer => {
            const { style } = layer;
            style.top = "0";
            style.left = "0";
            style.transform = "";
        });
    }

    makeTextRenderer = searchText => textItem => highlightPattern(textItem.str, searchText);

    setPage = (event) => {
        this.setState({
            pageNumber: parseInt(event.target.value)
        })
    }

    switchFullScreen = () => {
        this.setState({
            open: !this.state.open
        })
    }

    renderFullScreen = () => {
        return (
            <Dialog fullScreen open={this.state.open}>
                <div style = {{
                    width: '100vw', 
                    height: '100vh',
                    backgroundColor: '#F0F0F0',
                    display:'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }} >
                    <Paper style = {{
                        width: '100vw', 
                        height: '50px', 
                        backgroundColor: '#FFFFFF',
                        padding: '5px',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                    }}
                    square
                    >   
                        <Typography style = {{marginLeft: '5px', flexGrow: 1}} variant = 'overline'>{this.props.filename}</Typography>
                        <div style = {{
                            display: 'flex', 
                            marginLeft: '15px', 
                            marginRight: '10px',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <TextField style = {{marginLeft: '5px', maxWidth: '35px'}}
                                display = 'inline' 
                                margin = 'dense' 
                                type ='number' 
                                value = {this.state.pageNumber}
                                onChange = {(event) => this.setPage(event)}
                            ></TextField>
                            <Typography variant = 'overline' display = 'inline'>/ {this.state.numPages}</Typography>
                            <div style = {{display: 'flex', flexDirection: 'row', marginLeft: '15px'}}>
                                <IconButton size = 'small' onClick = {this.props.prevPage(parseInt(this.props.pageNumber))}>
                                    <KeyboardArrowLeft></KeyboardArrowLeft>
                                </IconButton>
                                <IconButton size = 'small' onClick = { this.props.nextPage(parseInt(this.props.pageNumber))}>
                                    <KeyboardArrowRight></KeyboardArrowRight>
                                </IconButton>
                            </div>
                        </div>
                        <div style = {{marginLeft: '15px', marginRight: '10px'}}>
                            <div style = {{display: 'flex', flexDirection: 'row', marginLeft: '15px'}}>
                                <IconButton size = 'small' onClick = {this.switchFullScreen}>
                                    <FullscreenExit></FullscreenExit>
                                </IconButton>
                                <IconButton 
                                    size = 'small'
                                    href = {this.props.downloadUrl}
                                    target="_blank"
                                    download
                                >
                                    <CloudDownload></CloudDownload>
                                </IconButton>
                            </div>
                        </div>
                    </Paper>
                    <div style = {{
                        width: '100%',
                        margin:'10px',
                        overflow: 'auto',
                        boxShadow: '0px 3px 10px 0px rgba(0,0,0,0.19)'
                    }}>
                        <Document
                        file={this.props.src}
                        onLoadSuccess={this.onDocumentLoadSuccess}
                        >
                            <Page 
                            renderMode = "canvas" 
                            renderTextLayer = {true} 
                            width = {toPx('vw') * 100} 
                            pageNumber={this.props.pageNumber}
                            onLoadSuccess={this.removeTextLayerOffset}
                            customTextRenderer={this.makeTextRenderer(this.state.searchText)}
                            />
                        </Document>
                    </div>
                </div>
            </Dialog>
        )
    }

    render() {
        console.log('PDF Viewer Props: ', this.props)
        return (
            <Fragment>
                <div style = {{
                    width: this.props.width + 'vw', 
                    height: this.props.height + 'vh',
                    display:'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center'
                }} >
                    <Paper style = {{
                        width: this.props.width + 'vw', 
                        height: '50px', 
                        backgroundColor: '#FFFFFF',
                        padding: '5px',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center'
                    }}
                    square
                    >   <Tooltip title = {this.props.filename}>
                            <Typography style = {{
                                width: '20%',
                                flexGrow: 1
                            }} 
                            variant = 'overline' 
                            noWrap = {true}
                            >{this.props.filename}</Typography>
                        </Tooltip>
                        <div style = {{
                            flexGrow: 1,
                            display: 'flex', 
                            marginLeft: '5px', 
                            marginRight: '10px',
                            flexDirection: 'row',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <Input style = {{marginLeft: '5px'}}
                                size = 'small'
                                display = 'inline' 
                                margin = 'none'
                                value = {this.props.pageNumber}
                                inputProps={{
                                    style: {fontSize: 12, maxWidth: '50px', textAlign: 'center'}
                                }}
                                endAdornment = {<InputAdornment style = {{fontSize: 12}} position="end">/ {this.state.numPages}</InputAdornment>}
                                onChange = {(event) => this.props.setPage(event.target.value)}
                            ></Input>
                            {/* <div style = {{display: 'flex', flexDirection: 'row', marginLeft: '15px'}}>
                                <IconButton size = 'small' onClick = {(event) => {
                                                                            event.preventDefault();
                                                                            this.props.prevPage(this.props.pageNumber)
                                                                            } }>
                                    <KeyboardArrowLeft></KeyboardArrowLeft>
                                </IconButton>
                                <IconButton size = 'small' onClick = {(event) => {
                                                                            event.preventDefault();
                                                                            this.props.nextPage(this.props.pageNumber)
                                                                        } }>
                                    <KeyboardArrowRight></KeyboardArrowRight>
                                </IconButton>
                            </div> */}
                        </div>
                        <div style = {{marginLeft: '15px', marginRight: '10px'}}>
                            <div style = {{display: 'flex', flexDirection: 'row', marginLeft: '15px'}}>
                                <IconButton size = 'small' onClick = {this.zoomIn}>
                                    <ZoomIn></ZoomIn>
                                </IconButton>
                                <IconButton size = 'small' onClick = {this.zoomOut}>
                                    <ZoomOut></ZoomOut>
                                </IconButton>
                            </div>
                        </div>
                        <div style = {{marginLeft: '15px', marginRight: '10px'}}>
                            <div style = {{display: 'flex', flexDirection: 'row', marginLeft: '15px'}}>
                                <IconButton size = 'small' onClick = {this.switchFullScreen}>
                                    <Fullscreen></Fullscreen>
                                </IconButton>
                                <IconButton 
                                    size = 'small' 
                                    href = {this.props.downloadUrl}
                                    target="_blank"
                                    download
                                >
                                    <CloudDownload></CloudDownload>
                                </IconButton>
                            </div>
                        </div>
                    </Paper>
                    <div style = {{
                        width: '100%',
                        margin:'10px',
                        height: 'calc('+ this.props.height + 'vh - 50px)', 
                        overflow: 'auto',
                        boxShadow: '0px 3px 10px 0px rgba(0,0,0,0.19)'
                    }}>
                        <Document
                        file={this.props.src}
                        onLoadSuccess={this.onDocumentLoadSuccess}
                        >
                            <Page 
                            renderMode = "canvas" 
                            renderTextLayer = {true} 
                            width = {this.state.containerWidth} 
                            pageNumber={parseInt(this.props.pageNumber)}
                            onLoadSuccess={this.removeTextLayerOffset}
                            customTextRenderer={this.makeTextRenderer(this.state.searchText)}
                            />
                        </Document>
                    </div>
                </div>
                {/* {this.renderFullScreen()} */}
            </Fragment>
        );
    }
}

export default PDFViewer;